import styled from 'react-emotion';
import { FONT_SIZE, LINE_HEIGHT, MEDIA_QUERIES, NTA_LIGHT } from '@govuk-react/constants';
var TopNavWrapper = styled('div')(function (_ref) {
  var _ref2;

  var bgColor = _ref.bgColor,
      color = _ref.color;
  return _ref2 = {
    display: 'flex',
    justifyContent: 'center',
    backgroundColor: bgColor,
    color: color,
    fontFamily: NTA_LIGHT,
    fontWeight: 400,
    fontSize: FONT_SIZE.SIZE_14,
    lineHeight: LINE_HEIGHT.SIZE_14
  }, _ref2[MEDIA_QUERIES.LARGESCREEN] = {
    fontSize: FONT_SIZE.SIZE_16,
    lineHeight: LINE_HEIGHT.SIZE_16
  }, _ref2;
});
export default TopNavWrapper;
//# sourceMappingURL=index.js.map


//////////////////
// WEBPACK FOOTER
// ./node_modules/@govuk-react/top-nav/es/atoms/top-nav-wrapper/index.js
// module id = 293
// module chunks = 0